import React from 'react';
import { Router } from 'react-router-dom';

import { ThemeProvider } from 'styled-components';

import history from './config/history';
import Routes from './routes/app.routes';
import GlobalStyles from './styles/globalStyles';
import theme from './styles/theme';

export default function App() {
  return (
    <Router history={history}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Routes />
      </ThemeProvider>
    </Router>
  );
}
